<template>
  <tr class="practice-row">
    <td class="practice-col">
      <lazy-image
        :src="user.thumbnailUrl"
        :lazy-src="require('@/assets/loggedPlaceholder96x96.png')"
        :alt="user.firstName + ' ' + user.lastName"
        wrapperClass="practice__avatar"
      />
    </td>
    <td class="practice-col">
      <h4 @click="$emit('to-user', user.id)" class="practice__name">
        {{ user.firstName }} {{ user.lastName }}
      </h4>
      <span class="pr-2">{{ user.isActive ? 'Active' : 'Inactive' }}</span>
    </td>
    <td class="practice-col"></td>
    <td class="practice-col">
      <v-tooltip bottom v-if="userHasPrograms">
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">
            {{ userFirstProgram.name }}
            <span v-if="userMoreProgramsCount > 0" style="display:"
              >&nbsp;(+&nbsp;{{ userMoreProgramsCount }}&nbsp;more)&nbsp;</span
            >
          </span>
        </template>
        <ul style="padding-left: 8px;">
          <li
            v-for="program in user.programs"
            :key="`user-${user.uuid}-program-${program.id}`"
          >
            {{ program.name }}
          </li>
        </ul>
      </v-tooltip>
    </td>
    <td class="practice-col">
      <strong>{{ dictionaryPracticeUserRole[user.roleId] }}</strong>
    </td>
    <td class="practice-col">
      <span class="bhGray2--text text-nowrap">
        {{ user.creationDate | moment('MMMM Do, YYYY') }}
      </span>
    </td>
    <td class="practice-col bh-user-col--full">
      <span class="bhGray2--text text-nowrap">
        {{ user.lastActivity | moment('MMMM Do, YYYY') }}
      </span>
    </td>
    <td class="practice-col" style="height: 100%;">
      <div class="d-flex align-center justify-end">
        <v-btn
          v-if="roleAllowedToSwitchAndManageOtherAccount"
          rounded
          color="accent"
          elevation="0"
          class="mr-2"
          @click="handleSwitchAccountNow"
        >
          <span>Switch now</span>
        </v-btn>
        <v-btn
          icon
          color="accent"
          elevation="0"
          @click="$emit('to-user', user.id)"
        >
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Config from '@/config.json'
import LazyImage from '../lazy/LazyImage.vue'

export default {
  components: { LazyImage },
  name: 'PracticeUsersTableRow',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
  methods: {
    ...mapMutations('appStates', ['setSnackbarNotification']),
    ...mapActions('bhUsersStates', ['generateSurrogateAuthToken']),
    handleSwitchAccountNow() {
      this.generateSurrogateAuthToken({
        userProfileId: this.getProfileId,
        username: this.user.email,
      })
        .then(res => {
          localStorage.clear()
          if (res.token) {
            window.location.href = `${Config.VUE_APP_CAS_URL_SHORT}/login?token=${res.token}`
          }
        })
        .catch(() => {
          this.setSnackbarNotification(
            `Something is wrong, don't worry and try again in few minutes.`,
          )
        })
    },
  },
  computed: {
    ...mapState('dictionariesStates', [
      'dictionaryPracticeUserRole',
      'dictionaryBhUsersRoleIds',
    ]),
    ...mapGetters('userStates', ['getRolename', 'getProfileId']),
    roleAllowedToSwitchAndManageOtherAccount() {
      return (
        this.dictionaryBhUsersRoleIds[this.getRolename] ===
          this.dictionaryBhUsersRoleIds.Admin &&
        this.user.roleId !== this.dictionaryBhUsersRoleIds.Admin
      )
    },
    userHasPrograms() {
      return (this.user?.programs || []).length > 0
    },
    userFirstProgram() {
      return this.user?.programs?.[0] || null
    },
    userMoreProgramsCount() {
      let length = (this.user?.programs || []).length || 0
      length -= 1
      return Math.max(0, length)
    },
  },
}
</script>

<style lang="scss">
.practice {
  &__name {
    // what about wrapping names?
    min-width: 150px;
    max-width: 200px;
    margin-bottom: 4px;
    cursor: pointer;

    // do we hant hover style?
    // &:hover {
    //   text-decoration: underline;
    // }
  }

  &__avatar {
    overflow: hidden;
    border-radius: 8px;
    width: 48px;
    height: 48px;
    .v-image {
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }

  &-row {
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.04);
    border-radius: $border-radius-root;

    &:hover {
      background: transparent !important;
    }
  }

  &-col {
    padding: 8px !important;
    border-bottom: 0 !important;
    background: $bh-white;

    strong {
      display: inline-block;
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    p {
      font-size: 0.857rem;
      line-height: 1rem;
    }

    p:last-child {
      margin-bottom: 0;
    }

    &:first-of-type {
      min-width: 0;
      border-top-left-radius: $border-radius-root;
      border-bottom-left-radius: $border-radius-root;
    }

    &:last-of-type {
      min-width: 0;
      border-top-right-radius: $border-radius-root;
      border-bottom-right-radius: $border-radius-root;
      text-align: right;
    }

    .text-number {
      font-size: 1.125rem;
    }
  }
}
</style>
